import { Component, OnInit } from '@angular/core';
import { SettingsService } from "../../../services/shared/settings.service";
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import {CustomValidators} from "@narik/custom-validators";

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

    public valForm: FormGroup;
    public passwordForm: FormGroup;

    constructor(public settings: SettingsService, fb: FormBuilder) {

        let password = new FormControl('',
          [Validators.required, Validators.pattern('^[a-zA-Z0-9]{6,10}$')]);
        let certainPassword = new FormControl('', [Validators.required, CustomValidators.equalTo(password)]);

        this.passwordForm = fb.group({
            'password': password,
            'confirmPassword': certainPassword
        });

        this.valForm = fb.group({
            'email': ['', [Validators.required, CustomValidators.email]],
            'accountagreed': ['', Validators.required],
            'passwordGroup': this.passwordForm
        });
    }

    public submitForm($ev, value: any) {
        $ev.preventDefault();
        for (let c in this.valForm.controls) {
            this.valForm.controls[c].markAsTouched();
        }
        for (let c in this.passwordForm.controls) {
            this.passwordForm.controls[c].markAsTouched();
        }

        if (this.valForm.valid) {
            console.log('Valid!');
            console.log(value);
        }
    }

    public ngOnInit() {
    }

}
